import useProtoMethod from "./useProtoMethod";
import {
  CreateCalendarEventRequest,
  CreateCalendarEventResponse,
  DeleteCalendarEventResponse,
  ListEventsRequest,
  ListEventsResponse,
  UpdateCalendarEventRequest,
  UpdateCalendarEventResponse,
  UpdateAttendeeStatusRequest,
  UpdateAttendeeStatusResponse,
  GetCalendarEventRequest,
  GetCalendarEventResponse,
  DeleteCalendarEventRequest,
  GetCalendarIntegrationsResponse,
  GetCalendarIntegrationsRequest,
  CreateCalendarIntegrationResponse,
  CreateCalendarIntegrationRequest,
  UpdateCalendarIntegrationResponse,
  UpdateCalendarIntegrationRequest,
  GenerateICSUrlRequest,
  GenerateICSUrlResponse,
  UpdateICSUrlRequest,
  UpdateICSUrlResponse,
  RevealICSUrlResponse,
  RevealICSUrlRequest,
  RefreshCalendarsRequest,
  RefreshCalendarsResponse,
  GetFamilyCalendarIntegrationsRequest,
  GetFamilyCalendarIntegrationsResponse,
} from "../protogen/calendar_service_pb";

const useCreateCalendarEvent = (
  callback?: (r: CreateCalendarEventResponse) => void,
) => {
  return useProtoMethod<
    CreateCalendarEventRequest,
    CreateCalendarEventResponse
  >("CreateCalendarEvent", CreateCalendarEventResponse, { callback });
};

const useCreateMemberCalendarEvent = (
  callback?: (r: CreateCalendarEventResponse) => void,
) => {
  return useProtoMethod<
    CreateCalendarEventRequest,
    CreateCalendarEventResponse
  >("CreateMemberCalendarEvent", CreateCalendarEventResponse, { callback });
};

const useListEvents = (callback?: (r: ListEventsResponse) => void) => {
  return useProtoMethod<ListEventsRequest, ListEventsResponse>(
    "ListEvents",
    ListEventsResponse,
    { callback },
  );
};

const useListMemberCalendarEvents = (
  callback?: (r: ListEventsResponse) => void,
) => {
  return useProtoMethod<ListEventsRequest, ListEventsResponse>(
    "ListMemberCalendarEvents",
    ListEventsResponse,
    { callback },
  );
};

const useUpdateCalendarEvent = (
  callback?: (r: UpdateCalendarEventResponse) => void,
) => {
  return useProtoMethod<
    UpdateCalendarEventRequest,
    UpdateCalendarEventResponse
  >("UpdateCalendarEvent", UpdateCalendarEventResponse, { callback });
};

const useUpdateMemberCalendarEvent = (
  callback?: (r: UpdateCalendarEventResponse) => void,
) => {
  return useProtoMethod<
    UpdateCalendarEventRequest,
    UpdateCalendarEventResponse
  >("UpdateMemberCalendarEvent", UpdateCalendarEventResponse, { callback });
};

const useDeleteCalendarEvent = (
  callback?: (r: DeleteCalendarEventResponse) => void,
) => {
  return useProtoMethod<
    DeleteCalendarEventRequest,
    DeleteCalendarEventResponse
  >("DeleteCalendarEvent", DeleteCalendarEventResponse, { callback });
};

const useDeleteMemberCalendarEvent = (
  callback?: (r: DeleteCalendarEventResponse) => void,
) => {
  return useProtoMethod<
    DeleteCalendarEventRequest,
    DeleteCalendarEventResponse
  >("DeleteMemberCalendarEvent", DeleteCalendarEventResponse, { callback });
};

const useHandleCalendarEvent = (
  callback?: (r: UpdateAttendeeStatusResponse) => void,
) => {
  return useProtoMethod<
    UpdateAttendeeStatusRequest,
    UpdateAttendeeStatusResponse
  >("UpdateAttendeeStatusResponse", UpdateAttendeeStatusResponse, { callback });
};

const useGetCalendarEvent = (
  callback?: (r: GetCalendarEventResponse) => void,
) => {
  return useProtoMethod<GetCalendarEventRequest, GetCalendarEventResponse>(
    "GetCalendarEvent",
    GetCalendarEventResponse,
    { callback },
  );
};

const useGetMemberCalendarEvent = (
  callback?: (r: GetCalendarEventResponse) => void,
) => {
  return useProtoMethod<GetCalendarEventRequest, GetCalendarEventResponse>(
    "GetMemberCalendarEvent",
    GetCalendarEventResponse,
    { callback },
  );
};

const useGetAdvisorCalendarIntegrations = (
  callback?: (r: GetCalendarIntegrationsResponse) => void,
) => {
  return useProtoMethod<
    GetCalendarIntegrationsRequest,
    GetCalendarIntegrationsResponse
  >("GetAdvisorCalendarIntegrations", GetCalendarIntegrationsResponse, {
    callback,
  });
};

const useGetMemberCalendarIntegrations = (
  callback?: (r: GetCalendarIntegrationsResponse) => void,
) => {
  return useProtoMethod<
    GetCalendarIntegrationsRequest,
    GetCalendarIntegrationsResponse
  >("GetMemberCalendarIntegrations", GetCalendarIntegrationsResponse, {
    callback,
  });
};

const useCreateCalendarIntegration = (
  callback?: (r: CreateCalendarIntegrationResponse) => void,
) => {
  return useProtoMethod<
    CreateCalendarIntegrationRequest,
    CreateCalendarIntegrationResponse
  >("CreateCalendarIntegration", CreateCalendarIntegrationResponse, {
    callback,
  });
};

const useUpdateCalendarIntegration = (
  callback?: (r: UpdateCalendarIntegrationResponse) => void,
) => {
  return useProtoMethod<
    UpdateCalendarIntegrationRequest,
    UpdateCalendarIntegrationResponse
  >("UpdateCalendarIntegration", UpdateCalendarIntegrationResponse, {
    callback,
  });
};

const useGenerateICSUrl = (callback?: (r: GenerateICSUrlResponse) => void) => {
  return useProtoMethod<GenerateICSUrlRequest, GenerateICSUrlResponse>(
    "GenerateICSUrl",
    GenerateICSUrlResponse,
    {
      callback,
    },
  );
};

const useUpdateICSUrl = (callback?: (r: UpdateICSUrlResponse) => void) => {
  return useProtoMethod<UpdateICSUrlRequest, UpdateICSUrlResponse>(
    "UpdateICSUrl",
    UpdateICSUrlResponse,
    {
      callback,
    },
  );
};

const useRevealICSUrl = (callback?: (r: UpdateICSUrlResponse) => void) => {
  return useProtoMethod<RevealICSUrlRequest, RevealICSUrlResponse>(
    "RevealICSUrl",
    RevealICSUrlResponse,
    {
      callback,
    },
  );
};

const useRefreshCalendars = (
  callback?: (r: RefreshCalendarsResponse) => void,
) => {
  return useProtoMethod<RefreshCalendarsRequest, RefreshCalendarsResponse>(
    "RefreshCalendars",
    RefreshCalendarsResponse,
    {
      callback,
    },
  );
};

const useGetFamilyCalendarIntegrations = (
  callback?: (r: GetFamilyCalendarIntegrationsResponse) => void,
) => {
  return useProtoMethod<
    GetFamilyCalendarIntegrationsRequest,
    GetFamilyCalendarIntegrationsResponse
  >("GetFamilyCalendarIntegrations", GetFamilyCalendarIntegrationsResponse, {
    callback,
  });
};

export {
  useCreateCalendarEvent,
  useListEvents,
  useUpdateCalendarEvent,
  useDeleteCalendarEvent,
  useHandleCalendarEvent,
  useGetCalendarEvent,
  useGetAdvisorCalendarIntegrations,
  useGetMemberCalendarIntegrations,
  useCreateCalendarIntegration,
  useUpdateCalendarIntegration,
  useGenerateICSUrl,
  useListMemberCalendarEvents,
  useUpdateICSUrl,
  useDeleteMemberCalendarEvent,
  useUpdateMemberCalendarEvent,
  useGetMemberCalendarEvent,
  useCreateMemberCalendarEvent,
  useRevealICSUrl,
  useRefreshCalendars,
  useGetFamilyCalendarIntegrations,
};
